export function resolveBrandLogo(
  logoType: 'emoji' | 'image',
  logoUrl: string | null | undefined,
  logoEmoji: string | null | undefined,
): string {
  return logoType === 'image' ? (logoUrl ?? '') : (logoEmoji ?? '');
}
